// extracted by mini-css-extract-plugin
export default {"label":"style_label__y42II","ico":"style_ico__PFHrQ","menu":"style_menu__5h1Pl"};